import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import DateTimePicker from 'react-datetime';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "./MyButton";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const sukienLayer = require("../lib/KeHoachTauLayer");

class KeHoachTauEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_tausar: true, // co dang load ding danh muc nguon tin ko
      source_tausar: [], //danh muc options cho nguon tin
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              TenTau: "",
              BatDau: null,
              KetThuc: null,
              TrangThai: 1,
              ViTri: "",
              GhiChu: "",
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TenTau",
      "BatDau",
      "KetThuc",
      "TrangThai",
      "ViTri",
      "GhiChu",
    ]);
    s.canSaved = s.dataChanged;
    console.log("before", s.before, "after", s.after);
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    if (this.props.EditMode !== "xoa") {
      var check = sukienLayer.validate(this.state.after);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post(
            "kehoachtau/saveKehoach",
            sukienLayer.chuanHoaKeHoach("abc", this.state.after)
          )
          .then((response) => {
            var before = {};
            var after = { ...this.state.after, KeHoachID: response.KeHoachID };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(after);
            }
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    }
    else {
      //thuc hien xoa
      this.setState({ saving: true, errorLog: "" });
        server
          .post(
            "kehoachtau/xoa",
            this.state.after
          )
          .then((response) => {
            var before = {};
            this.setState({
              saving: false,
              errorLog: "",
            });
            this.handleClose();
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("tausar/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.TenTau, label: item.TenTau })
        );
        this.setState({ source_tausar: list, loading_tausar: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_tausar: false });
      });
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.KeHoachID;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("kehoachtau/get?kehoachid=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = response;
          sukien = sukienLayer.chuyenDoi(sukien); //chuyen doi gia tri
          console.log(sukien, "chuyen doi");
          this.setState({
            formReady: true,
            before: sukien,
            after: myLib.cloneObject(sukien),
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_coquan: false, errorLog: error + "" });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Kế hoạch chốt chặn tàu SAR
                </Typography>
                {this.props.EditMode === 'xoa' ?
                <Button color="inherit" onClick={this.handleSave}>
                  Xóa
                </Button>                : null}
                <Button color="inherit" onClick={this.handleClose}>
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 250 }}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <InputLabel id="labelCoquan">Tên tàu:</InputLabel>
                    {this.state.loading_tausar ? (
                      <CircularProgress />
                    ) : (
                      <div style={{ zIndex: 99999 }}>
                        <SelectFilter
                          id="cboTenTau"
                          options={this.state.source_tausar}
                          placeholder=""
                          labelId="labelCoquan"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition={"fixed"}
                          value={this.state.after.TenTau}
                          onChange={(item) => this.saveField("TenTau", item)}
                        ></SelectFilter>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-simple-select-label">
                        Kế hoạch:
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className={classes.textbox}
                        autoWidth={true}
                        labelWidth={100}
                        value={this.state.after.TrangThai}
                        onChange={(event) =>
                          this.saveField("TrangThai", event.target.value)
                        }
                      >
                        <MenuItem value={"1"}>Chốt chặn</MenuItem>
                        <MenuItem value={"0"}>Thường trực</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    
                    <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.BatDau !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Bắt đầu(*):
              </InputLabel>
              <DateTimePicker
                id="txtBatDau"
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                closeOnSelect={true}
                value={this.state.after.BatDau}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.BatDau === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('BatDau', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField("BatDau", date && date.toDate ? date.toDate() : null)
                }
              />
                  </Grid>
                  <Grid item xs={6}>
                  <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.KetThuc !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Kết thúc(*):
              </InputLabel>
              <DateTimePicker
                id="txtKetThuc"
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                closeOnSelect={true}
                value={this.state.after.KetThuc}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.KetThuc === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('KetThuc', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField("KetThuc", date && date.toDate ? date.toDate() : null)
                }
              />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="txtViTri"
                      className={classes.textbox}
                      label="Vị trí:"
                      value={this.state.after.ViTri}
                      inputProps={{
                        maxLength: 50,
                      }}
                      onChange={(event) =>
                        this.saveField("ViTri", event.target.value)
                      }
                      error={this.state.validateStatus.ViTri !== undefined}
                      helperText={
                        this.state.validateStatus.ViTri !== undefined
                          ? this.state.validateStatus.ViTri.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="txtGhiChu"
                      className={classes.textbox}
                      label="Ghi chú:"
                      value={this.state.after.GhiChu}
                      inputProps={{
                        maxLength: 100,
                      }}
                      onChange={(event) =>
                        this.saveField("GhiChu", event.target.value)
                      }
                      error={this.state.validateStatus.GhiChu !== undefined}
                      helperText={
                        this.state.validateStatus.GhiChu !== undefined
                          ? this.state.validateStatus.GhiChu.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== 'xoa' ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null }
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },  
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
});
export default withStyles(styles, { withTheme: true })(KeHoachTauEditDialog);
